import { render } from "./WishList.vue?vue&type=template&id=15240f8f&ts=true"
import script from "./WishList.vue?vue&type=script&lang=ts"
export * from "./WishList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__